import { useAppSelector } from "app/hooks";
import { selectCurrentPractice } from "features/auth/auth-slice";

// The gate for Suno's hot-desking entry points (ENG-2293): the practice's
// `hot_desking_enabled` switch, flipped by Suno staff from Voice Setup. Voice
// itself is gated separately (`usePracticeVoiceEnabled`), and the phone's own
// keypad login works regardless — this only decides what the app offers.
export default function usePracticeHotDeskingEnabled(): boolean {
  const currentPractice = useAppSelector(selectCurrentPractice);
  return Boolean(
    currentPractice?.voice_enabled && currentPractice?.hot_desking_enabled
  );
}
